import { message } from 'antd';
import { AppInsights } from "applicationinsights-js";

import * as t from './actionTypes';
import * as constants from './constants';
import common from '../../common';
import uistate from '../uistate';

export function loadDossierFiles(idDossier) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.CLEAR_FILES,
        });

        let lang = getState().uistate.appsettings.lang
        const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/dossiers/files/${idDossier}?lang=${lang}`);
        dispatch({
            type: t.LOAD_FILES,
            payload: resp.data
        });
    };
}

export function deleteDossierFile(idDossier, id) {
    return async (dispatch, getState) => {
        try {
            const resp = await common.apiClient.delete(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/dossiers/files/${idDossier}/${id}`);
            message.success('item deleted.');
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

export function updateDossierFile(idDossier, file) {
    return async (dispatch, getState) => {
        try {
            const resp = await common.apiClient.put(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/dossiers/files/${idDossier}`, file);
            message.success('item updated.');
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}

export function createDossierFile(idDossier, values) {
    return async (dispatch, getState) => {

        //formdata en header instellen, evt uitbreiden als er extra velden bij komen...
        const formData = new FormData();
        formData.append('file', values.file);
        formData.append('idFileType', values.idFileType);
        formData.append('description', values.description);
        if (values.date) {
            formData.append('date', values.date);
        }

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        try {
            const resp = await common.apiClient.post(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/dossiers/files/upload/${idDossier}`, formData, config);
            message.success('File saved.', 5);
        } catch (error) {
            message.error('Error saving file.', 5)
            AppInsights.trackException(error);
        }
    };
}

export function openLinkedDossierFile(idlinkedfile) {

    return async (dispatch, getState) => {
        try {
            const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/dossiers/downloadurl/${idlinkedfile}`);
            if (resp.data.url) {
                window.open(resp.data.url, '_blank');
            } else {
                message.error('unknown response, file not found...')
            }
        } catch (error) {
            AppInsights.trackException(error);
        }
    };
}




